import '~/utils/prototypesExtensions';

import { lazy, useMemo, Suspense } from 'react';

import { noop } from '@mindtickle/utils';

import useBaseDomain from '../BaseDomain/useBaseDomain';
import { MicroApps, DynamicApps, ExternalApps } from '~/components/Auth/constants';
import StyledAuthLoader from './style';
import LocalAuthProvider from './LocalAuthProvider';

//@ts-ignore
const UserAuthProvider = lazy(() => import('ui_auth/App'));

function Provider({
  children,
  loader,
  appName,
  onAuthLoaded = noop,
}: {
  children?: JSX.Element;
  loader?: JSX.Element;
  appName?: string;
  onAuthLoaded?: () => void;
}) {
  const baseDomain = useBaseDomain();
  const localeForApps = useMemo(() => {
    if (appName && !MicroApps.includes(appName)) {
      return [...MicroApps, appName];
    }
    return [...MicroApps, ...DynamicApps, ...ExternalApps];
  }, [appName]);

  return (
    <Suspense fallback={loader ? loader : <StyledAuthLoader type="Full" />}>
      <UserAuthProvider
        isOld={true}
        baseDomain={baseDomain}
        localeForApps={localeForApps}
        shellTrack={process.env.UI_SHELL_TRACK}
        loader={loader ? loader : <StyledAuthLoader type="Full" />}
        onAuthLoaded={onAuthLoaded}
      >
        <LocalAuthProvider>{children}</LocalAuthProvider>
      </UserAuthProvider>
    </Suspense>
  );
}
export default Provider;
